export enum Applications {
    WORKSPACE = 'WORKSPACE',
    CONTRACT = 'CONTRACT',
    WORKFLOW = 'WORKFLOW',
    PAYROLL = 'PAYROLL',
    PERFS = 'PERFS',
    ATS = 'ATS',
  }